import React from "react";

const ChooseSubscriptionIcon = (props: any) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x={4} y={2} width={2} height={20} rx={1} fill="#FFFCF4" />
    <path
      d="M5.5 4h-1v2h1V4Zm13.591 2.514.858.515-.858-.514ZM17 10l-.858-.514a1 1 0 0 0 0 1.028L17 10Zm2.091 3.486.858-.515-.858.514ZM5.5 14a1 1 0 1 0 0 2v-2Zm0-8h12.734V4H5.5v2Zm12.734 0-2.092 3.486 1.716 1.028 2.09-3.485L18.235 6Zm-2.092 4.514L18.234 14l1.715-1.029-2.091-3.486-1.716 1.03ZM18.234 14H5.5v2h12.734v-2Zm0 0v2c1.554 0 2.515-1.696 1.715-3.029L18.234 14Zm0-8 1.715 1.029c.8-1.333-.16-3.029-1.715-3.029v2Z"
      fill="#FFFCF4"
    />
  </svg>
);

export default ChooseSubscriptionIcon;
